import { useState, useEffect } from "react";
import GlobalIcon from "../images/global.svg";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  // Bahar click karne par dropdown band karne ke liye
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);

    const currentPath = location.pathname;
    let pathParts = currentPath.split("/").filter(Boolean);

    // Check if first part is a language code
    if (
      pathParts.length > 0 &&
      (pathParts[0] === "en" || pathParts[0] === "de")
    ) {
      pathParts[0] = lng;
    } else {
      // If no language code in URL, add it at the beginning
      pathParts.unshift(lng);
    }

    const newPath = `/${pathParts.join("/")}${location.search}${location.hash}`;
    navigate(newPath);
    setIsOpen(false);
  };
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) setMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ── Get current language prefix ───────────────────────────────────────
  const getLangPrefix = () => {
    const parts = location.pathname.split("/").filter(Boolean);
    return parts[0] === "en" || parts[0] === "de" ? `/${parts[0]}` : "";
  };

  // ── Scroll to hash after cross-page navigation ────────────────────────
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const navHeight = 104;
          const top = el.getBoundingClientRect().top + window.scrollY - navHeight;
          window.scrollTo({ top, behavior: "smooth" });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location.hash]);

  // ── Smooth scroll handler ──────────────────────────────────────────────
  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);

    const id = href.replace("#", "");
    const el = document.getElementById(id);

    if (el) {
      // Element exists on current page — smooth scroll
      const navHeight = 104;
      const top = el.getBoundingClientRect().top + window.scrollY - navHeight;
      window.scrollTo({ top, behavior: "smooth" });
    } else {
      // On a different page — navigate home with hash, useEffect above will scroll
      navigate(`${getLangPrefix()}/${href}`);
    }
  };

  const navLinks = [
    { label: "Fill out the form", href: "#formular" },
    { label: "How it works", href: "#how-it-works" },
    { label: "Benefits", href: "#benefits" },
    { label: "FAQ's", href: "#faqs" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      {/* ── Top Bar ── */}
      <div
        className={`bg-black w-full transition-all duration-500 ease-in-out ${
          scrolled
            ? "max-h-0 opacity-0 overflow-hidden"
            : "max-h-[60px] opacity-100 overflow-visible"
        }`}>
        {/* Yahan 'overflow-visible' zaroori hai taaki dropdown niche bahar nikal sake */}
        <div className="max-w-[1536px] mx-auto px-6 md:px-10 py-2 flex items-center justify-between">
          <span className="text-xs font-medium tracking-wide text-white flex gap-2 items-center">
            {/* {t("CH Serving All Cantons | Secure Handling")} */}
            <span className="flex items-center justify-center w-7 h-7 rounded-sm overflow-hidden shrink-0">
                <img src="/images/swiss_flag.png" alt="swiss_flag"/>
            </span> {t("availableCantons")}

          </span>

          <div
            className="relative inline-block"
            ref={dropdownRef}
            style={{ zIndex: 1000 }}>
            <button
              type="button"
              className="flex items-center justify-center p-2 transition-colors rounded-full cursor-pointer hover:bg-white/20"
              onClick={(e) => {
                e.stopPropagation(); // Parent events ko rokne ke liye
                setIsOpen(!isOpen);
              }}>
              <img
                src={GlobalIcon}
                alt="Language"
                className="w-5 h-5 brightness-0 invert" // Black icon ko white karne ke liye
              />
            </button>

            {/* DROPDOWN MENU */}
            {/* DROPDOWN MENU */}
            {isOpen && (
              <div className="absolute right-0 w-40 mt-2 overflow-hidden bg-white border shadow-2xl top-full border-slate-200 rounded-xl">
                <div className="flex flex-col">
                  {/* English Button */}
                  <button
                    onClick={() => changeLanguage("en")} // Yahan changeLanguage function call karein
                    className="flex items-center gap-3 px-4 py-3 text-sm border-b text-slate-700 hover:bg-slate-50 border-slate-100 last:border-none">
                    <img
                      src="https://flagcdn.com/w40/gb.png"
                      className="w-5 h-auto rounded-sm"
                      alt="EN"
                    />
                    <span>English</span>
                  </button>

                  {/* German Button */}
                  <button
                    onClick={() => changeLanguage("de")} // Yahan bhi custom function call karein
                    className="flex items-center gap-3 px-4 py-3 text-sm text-slate-700 hover:bg-slate-50">
                    <img
                      src="https://flagcdn.com/w40/de.png"
                      className="w-5 h-auto rounded-sm"
                      alt="DE"
                    />
                    <span>Deutsch</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ── Navbar ── */}
      <div className="w-full px-4 mt-2 md:px-10">
        <nav
          className={`bg-white w-full max-w-[1536px] mx-auto rounded-xl overflow-hidden transition-all duration-300 ${
            scrolled ? "shadow-lg" : "shadow-sm border border-gray-100"
          }`}>
          <div className="h-[60px] px-6 md:px-10 flex items-center justify-between gap-6">
            {/* <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                const prefix = getLangPrefix();
                navigate(prefix || "/");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-poppins font-black text-base md:text-lg tracking-[0.1em] text-black uppercase no-underline shrink-0"
            >
              SwissTaxFile
            </a> */}
            <a
              href="/"
              // onClick={(e) => {
              //   e.preventDefault();
              //   window.scrollTo({ top: 0, behavior: "smooth" });
              // }}
              className="flex items-center gap-2 font-poppins font-black text-base md:text-lg tracking-[0.1em] text-black uppercase no-underline shrink-0"
            >
              <img
                src="/images/swiss_taxfile_logo.webp"
                alt="SwissTaxFile Logo"
                className="h-6 w-auto md:h-10"
              />

            </a>

            <ul className="items-center justify-center hidden gap-8 p-0 m-0 list-none md:flex">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-gray-600 text-[14px] font-medium hover:text-[#007AB7] transition-colors duration-200 no-underline whitespace-nowrap cursor-pointer">
                    {t(link.label)}
                  </a>
                </li>
              ))}

              {/* <li>
                {user ? (
                  <button
                    onClick={() => {
                      logout();
                      navigate(`/${i18n.language}/login`);
                    }}
                    className="text-[#007AB7] text-[14px] font-medium transition-colors duration-200 cursor-pointer border border-[#007AB7]  bg-transparent px-2 py-1 rounded-lg whitespace-nowrap"
                  >
                    Logout
                  </button>
                ) : (
                  <button
                    onClick={() => navigate(`/${i18n.language}/login`)}
                    className="text-white text-[14px] font-medium transition-colors duration-200 cursor-pointer border-none px-2 py-1 rounded-lg bg-[#007AB7] whitespace-nowrap"
                  >
                    Login
                  </button>
                )}
              </li> */}
            </ul>

            {/* <a
              href="#questionnaire"
              onClick={(e) => handleNavClick(e, "#questionnaire")}
              className="hidden md:inline-flex items-center gap-2 bg-[#007AB7] hover:bg-[#005f8d] text-white text-[13px] font-semibold font-poppins px-4 py-2 rounded-lg no-underline transition-all duration-200 hover:-translate-y-px shrink-0 whitespace-nowrap">
              {t("Start Filing")}
              <ArrowRight size={16} />
            </a> */}

            {/* Mobile Hamburger */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="md:hidden flex items-center justify-center p-1.5 rounded-md text-gray-700 hover:bg-gray-100 transition-colors border-none bg-transparent cursor-pointer"
              aria-label="Toggle menu">
              {menuOpen ? (
                <svg width="20" height="20" viewBox="0 0 22 22" fill="none">
                  <path
                    d="M5 5l12 12M17 5L5 17"
                    stroke="#111"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 22 22" fill="none">
                  <path
                    d="M3 6h16M3 11h16M3 16h16"
                    stroke="#111"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              )}
            </button>
          </div>

          {/* Mobile Dropdown */}
          <div
            className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out border-t border-gray-100 bg-white ${
              menuOpen ? "max-h-72 opacity-100" : "max-h-0 opacity-0"
            }`}>
            <div className="flex flex-col px-5 py-2">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-gray-700 text-sm font-medium py-3 border-b border-gray-50 last:border-none hover:text-[#007AB7] transition-colors no-underline cursor-pointer">
                  {t(link.label)}
                </a>
              ))}
              {/* <div className="py-2">
                {user ? (
                  <button
                    onClick={() => {
                      logout();
                      navigate(`/${i18n.language}/login`);
                    }}
                    className="text-[#007AB7] text-[14px] font-medium transition-colors duration-200 cursor-pointer border border-[#007AB7]  bg-transparent px-2 py-1 rounded-lg whitespace-nowrap"
                  >
                    Logout
                  </button>
                ) : (
                  <button
                    onClick={() => navigate(`/${i18n.language}/login`)}
                    className="text-white text-[14px] font-medium transition-colors duration-200 cursor-pointer border-none px-2 py-1 rounded-lg bg-[#007AB7] whitespace-nowrap"
                  >
                    Login
                  </button>
                )}
              </div> */}
              {/* <a
                href="#questionnaire"
                onClick={(e) => handleNavClick(e, "#questionnaire")}
                className="mt-3 mb-2 bg-[#007AB7] hover:bg-[#005f8d] text-white text-sm font-semibold text-center py-2.5 rounded-lg no-underline transition-colors cursor-pointer">
                {t("Start Filing")}{" "}
                <ArrowRight size={16} className="inline-block ml-1" />
              </a> */}
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
}